import PreparePlanCommunication from '~/pages/communication/preparePlan/libs/components/PreparePlanCommunication'
import { TPageProps } from '~/shared/types/commonTypes'

const PreparePlanCommunicationPage = (props: TPageProps) => (
  <PreparePlanCommunication {...props} />
)

export default PreparePlanCommunicationPage
